// Register project view templates into the shared registry (built in 01.init.js).
// Runs after base and optional middle-layer (e.g. bigbang-base) plugins so that
// project templates have the highest override priority.
const _projectFiles = import.meta.glob('@/components/views/**/*.vue');

const _parse = (path, ref) =>
	path
		.replace(ref, '')
		.replace('.vue', '')
		.split('/')
		.map(el => el.charAt(0).toUpperCase() + el.slice(1))
		.filter(el => el !== 'Index')
		.join('');

export default defineNuxtPlugin(nuxtApp => {
	Object.entries(_projectFiles).forEach(([path, loader]) => {
		nuxtApp.$appData.templates.set(_parse(path, '/components/views/'), loader);
	});
});
